import { PersonalDataActionEnum } from '../../consts/actionTypes';
import { IPersonalData } from '../../interfaces/IRequestForm';

export const PersonalDataActionCreators = {
    setPersonalData: (personalData: Partial<IPersonalData>) => ({
        type: PersonalDataActionEnum.SET_PERSONALDATA,
        payload: personalData,
    }),
};
